// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__S9Md3","option":"styles_option__2Xivq","selected":"styles_selected__1GeQK"};